import ReactPaginate from "react-paginate"
import "../index.css"
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react"
export const Pagination = ({ offset, setOffset, handlePageChange, pageCount }) => {
    return (
        <div className="d-flex justify-content-center align-items-center align-self-center mt-0" >
            <div className="d-flex align-items-center gap-0">
                {/* First Page Button */}
                <button
                    onClick={() => setOffset(0)}
                    disabled={offset === 0}
                    className="page-link first-last-btn"
                    style={{
                        padding: '8px 12px',
                        border: '1px solid #dee2e6',
                        borderRadius: '4px',
                        backgroundColor: offset === 0 ? '#f8f9fa' : 'white',
                        color: offset === 0 ? '#6c757d' : '#7a3a5e',
                        cursor: offset === 0 ? 'not-allowed' : 'pointer',
                        opacity: offset === 0 ? 0.5 : 1
                    }}
                >
                    ««
                </button>

                {/* React Paginate */}
                <ReactPaginate
                    previousLabel={<span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <IconChevronLeft stroke={2} style={{ width: '16px', height: '16px' }} />
                        Previous
                    </span>}
                    nextLabel={<span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        Next
                        <IconChevronRight stroke={2} style={{ width: '16px', height: '16px' }} />
                    </span>}
                    breakLabel={"..."}
                    pageCount={pageCount}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={3}
                    onPageChange={handlePageChange}
                    forcePage={offset}
                    containerClassName="pagination d-flex align-items-center gap-0 mb-0"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    activeClassName="active"
                    disabledClassName="disabled"
                />

                {/* Last Page Button */}
                <button
                    onClick={() => setOffset(pageCount - 1)}
                    disabled={offset === pageCount - 1}
                    className="page-link first-last-btn"
                    style={{
                        padding: '8px 12px',
                        border: '1px solid #dee2e6',
                        borderRadius: '4px',
                        backgroundColor: offset === pageCount - 1 ? '#f8f9fa' : 'white',
                        color: offset === pageCount - 1 ? '#6c757d' : '#7a3a5e',
                        cursor: offset === pageCount - 1 ? 'not-allowed' : 'pointer',
                        opacity: offset === pageCount - 1 ? 0.5 : 1
                    }}
                >
                    »»
                </button>
            </div>
        </div>
    )
}
